module.exports = __webpack_public_path__ + "static/media/almofada3.f02bf4d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/almofada3.png
// module id = 50
// module chunks = 0